import LabeledVertical from '../../../components/raExtend/labels/LabeledVertical';
import ImageWithOverlayBorder from '../../../components/ui/ImageWithOverlayBorder';
import { useRecordContext, useTranslate } from 'ra-core';
import { Offer } from '../types';
import MoneyField from '../../../components/raExtend/fields/MoneyField';

function LastNegotiation() {
  const t = useTranslate();
  const offer = useRecordContext<Offer>();

  if (!offer) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 w-full gap-4">
      <LabeledVertical label={t('common.text.brand')} separator="">
        <div className="flex gap-2 items-center">
          <ImageWithOverlayBorder
            src={offer.brand.logo}
            alt="Offer brand logo"
            width={32}
            height={32}
            className="shrink-0"
          />
          <span className="text-sm font-medium text-foreground">
            {offer.name}
          </span>
        </div>
      </LabeledVertical>

      <LabeledVertical label={t('common.text.total_budget')} separator="">
        <MoneyField<Offer> source="last_negotiation.budget_total" />
      </LabeledVertical>

      <LabeledVertical label={t('common.text.pricing_model')} separator="">
        <p className="text-muted-foreground text-base">
          {t(`offer.pricing_model.${offer.last_negotiation.pricing_model}`)}
        </p>
      </LabeledVertical>

      {offer.last_negotiation.rate > 0 && (
        <LabeledVertical label={t('common.text.rate')} separator="">
          <MoneyField<Offer> source="last_negotiation.rate" />
        </LabeledVertical>
      )}
      <div className="col-span-full">
        <LabeledVertical label={t('common.text.message')} separator="">
          <span className="text-sm text-foreground">
            {offer.last_negotiation?.action_note || '-'}
          </span>
        </LabeledVertical>
      </div>
    </div>
  );
}

export default LastNegotiation;
